/* 
For related-insights and related-news components (components/related-insights and components/related-news).
Click handler for slider cards.  No longer uses anchor href attribute.
*/

const carousels = document.querySelectorAll('.image-cards-carousel');

carousels?.forEach((carousel) => {
    carousel?.querySelectorAll('.js-card-link').forEach((anchor) => {
        // Add click event listener to handle the tracking and navigation

        anchor.addEventListener('click', function (event) {
            event.preventDefault(); // Prevent default anchor behavior

            const clicktrackingValue = anchor.getAttribute('data-clicktracking');
            const dataHref = anchor.getAttribute('data-href');

            if (dataHref && dataHref !== '') {
                // Only proceed with fetch if there's a tracking URL
                if (clicktrackingValue) {
                    // Send tracking data and navigate after it completes
                    fetch(clicktrackingValue)
                        .then((response) => response.json())
                        .then((data) => {
                            window.location.assign(dataHref);
                        })
                        .catch((error) => {
                            console.error('Error fetching data:', error);
                            // Still navigate even if tracking fails
                            window.location.assign(dataHref);
                        });
                } else {
                    // If no tracking URL, just navigate
                    window.location.assign(dataHref);
                }
            }
        });
    });
});